export default __webpack_public_path__ + "static/media/icon-add.835dd095.svg";